import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("chalet_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Original chalet-steiermark.com (Wix CDN) — used for Hero + Unit cards.
const WIX = "https://static.wixstatic.com/media";

const wix = {
  heroSnow:       `${WIX}/11062b_e9c961ed3af942a3ba1d47cc215f5440~mv2.jpg`,
  exteriorWinter: `${WIX}/cb2c1f_61287a9681954997858e0dfde30b6b81~mv2.jpg`,
  zirbenInterior: `${WIX}/cb2c1f_d28b6022250249c484aaa2d09c4017e6~mv2.jpg`,
  living:         `${WIX}/cb2c1f_e2ee1080f4754457a385b67806402f5b~mv2.png`,
  kitchen:        `${WIX}/cb2c1f_61ae822305654b1e950932d21337fb47~mv2.png`,
  bedroom1:       `${WIX}/cb2c1f_a6a23047971c415d8d98442c8cbab99f~mv2.png`,
  bedroom3:       `${WIX}/cb2c1f_a606dae62a2a47bdacb03f97bc859b0c~mv2.png`,
  garden:         `${WIX}/cb2c1f_27fc2d264d1c409e99271b011e956505~mv2.png`,
};

// Booking.com CDN photos — actual Chalet Steiermark property photos
const BC = "https://cf.bstatic.com/xdata/images/hotel";
const booking = {
  winterHero:  `${BC}/max1280x900/925061749.jpg?k=6938fbe0051eb95d77e6c39f9bfc2da5ad221dc00265c850a2c40878adbeaaf1&o=`,
  bedroom:     `${BC}/max1024x768/822413803.jpg?k=e014891534666cc2dab926ddea8d9e492faf8129c24bae1ee5eac6f59e689b47&o=`,
  bathroom:    `${BC}/max1024x768/925059691.jpg?k=6177defe5e5dee6b838ee58cab4000d9c5275ff714eee93bf2d51c47b5f31df6&o=`,
  kitchen:     `${BC}/max1024x768/822413792.jpg?k=ce00045876cc3013cb405fa061c35abe36689149516799d3f18a803f932caed3&o=`,
  livingroom:  `${BC}/max1024x768/822413790.jpg?k=e3002d5c615dd165fdd993c867e796304d0c89dc1063cbc07d2c402c35819e7a&o=`,
  garden:      `${BC}/max1024x768/925198466.jpg?k=b3fa4f66a07b80577e9aeb2444fbc36608e41ed8abba704db47529c32bf067e8&o=`,
  bedroomWood: `${BC}/max1024x768/925054096.jpg?k=772323d87e5124261c5c2530363ba34f082d620387e282f23a62f6a49fd358c7&o=`,
};

// Authentic Landhaus photos from chalet-steiermark.com/kopie-von-das-chalet-1
const landhausPhotos = [
  `${WIX}/cb2c1f_8577ac7849214ab99ff260b47c6a65a6~mv2.jpg`,
  `${WIX}/cb2c1f_312f863f83974f40ade0ba5dcef0f052~mv2.jpg`,
  `${WIX}/cb2c1f_cf6a12fae7e045c187ad473f10787f6a~mv2.jpg`,
  `${WIX}/cb2c1f_cbb26617378c4dd1aa2e14091783d2cf~mv2.jpg`,
  `${WIX}/cb2c1f_228824676af443cfa405b6c571d14649~mv2.jpg`,
  `${WIX}/cb2c1f_63883a7092064a8da329d49a4b9477f7~mv2.jpg`,
  `${WIX}/cb2c1f_1a6adba830c340849d029f984c77a4ef~mv2.jpg`,
  `${WIX}/cb2c1f_5166f2cdc8b54156b22d70d08439a3cf~mv2.jpg`,
  `${WIX}/cb2c1f_ded3195b544b44909c9f769411f0ea18~mv2.jpg`,
  `${WIX}/cb2c1f_93a23d4d4cf94ef8a6e0ea1dbcf58f14~mv2.jpg`,
  `${WIX}/cb2c1f_a54c322698724d6c90cc68df86d47498~mv2.jpg`,
];

// Curated alpine stock imagery — used in gallery / property / rooms / location.
const stock = {
  alpineExterior: "https://images.pexels.com/photos/31299068/pexels-photo-31299068.jpeg",
  cozyInterior:   "https://images.unsplash.com/photo-1780391592801-5e8867523492?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  cozyInteriorAlt:"https://images.unsplash.com/photo-1758116448135-e989799305da?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  bedroomLuxe:    "https://images.pexels.com/photos/34961766/pexels-photo-34961766.jpeg",
  bedroomLuxeAlt: "https://images.pexels.com/photos/35868592/pexels-photo-35868592.jpeg",
  mountain:       "https://images.unsplash.com/photo-1541456419250-8f26bb3335ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  mountainAlt:    "https://images.unsplash.com/photo-1644670039102-9c82858272bd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  redbull:        `${WIX}/cb2c1f_32dec6cc55b249cc94cb9a4881ca4012~mv2.jpg`,
  gold:           `${WIX}/cb2c1f_afd98cbba11e4376bc63ba4223b9cc9e~mv2.jpg`,
};

// Nature imagery — Pusterwald & Steirische Alpen surroundings.
export const nature = {
  alpineMeadow:   "https://images.unsplash.com/photo-1596407404794-c77ec8383e70?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",  // green alpine meadow with peaks
  forestPath:     "https://images.unsplash.com/photo-1760030779295-817cae55351c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",  // scenic forest path beside clear lake
  mountainLake:   "https://images.unsplash.com/photo-1636619314457-2a8a67754b6b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",  // turquoise alpine lake green trees
  wildlifeDeer:   "https://images.unsplash.com/photo-1537694513497-5f0b0ec361c7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",  // deer portrait in forest
  waterfall:      "https://images.unsplash.com/photo-1768502878675-1e3c166a3b42?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",  // waterfall cascading into clear river
  panorama:       "https://images.unsplash.com/photo-1767034553714-3d877cb003d0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",  // golden hour mountain peak blue sky
  autumn:         "https://images.unsplash.com/photo-1783104122400-d5550ad5dafb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",  // autumn trail towards mountains
  cows:           "https://images.pexels.com/photos/533986/pexels-photo-533986.jpeg?cs=srgb&w=1600",                      // alm cows pasture
};

// ---- Real Chalet photos from Object Storage ----
const S = `${BASE}/api/files/chalet-steiermark/uploads/772b41aa-c8ff-408a-8edb-de7ff568e465`;
const chalet = {
  kueche1:      `${S}/53f79ef533a84179a8ae9fabe5a04070.jpg`,  // Kueche Gesamtansicht
  kueche2:      `${S}/974f1b423880424c996ebcae19793610.jpg`,  // Kueche Ausstattung
  wohnzimmer1:  `${S}/2fd5c6bc84af4909962037e581d2b0fa.jpg`,  // Wohnzimmer Gesamt
  wohnzimmer2:  `${S}/5a850a43d4a343b895ce19dffe6038a8.jpg`,  // Wohnzimmer Sitzecke
  essen1:       `${S}/83a0db8d9a23406ea35612464e68f38d.jpg`,  // Essbereich Gesamt
  essen2:       `${S}/e30589e229c1497f82d02c3cecc02e6f.jpg`,  // Essbereich Atmosphaere
  schlaf1a:     `${S}/4319cf8b91ea41e18db6c7f3e9ccf8a1.jpg`,  // Schlafzimmer 1 Gesamt
  schlaf1b:     `${S}/80b7ccd6775b4b27b7d057ba878710a9.jpg`,  // Schlafzimmer 1 Perspektive 2
  schlaf2a:     `${S}/3e6f7e64c90249eb8cb16274f4fdbde1.jpg`,  // Schlafzimmer 2 Gesamt
  schlaf2b:     `${S}/0622b2f47f7542ec885697dbe6f74c3f.jpg`,  // Schlafzimmer 2 Perspektive 2
  bad1:         `${S}/a8df3682121c46218a31729af74e611d.jpg`,  // Bad Gesamt
  bad2:         `${S}/0f86097f04f04bb1adaca13c6a6d2812.jpg`,  // Bad Perspektive 2
  gang1:        `${S}/772e16cece7440a4b5503014427ce4bb.jpg`,  // Gang Gesamt
  gang2:        `${S}/1e654789429b44e196664b39a1e384d1.jpg`,  // Gang Perspektive 2
  aussen1:      `${S}/9acf21a529464e95822a62b709064d70.jpg`,  // Chalet Aussen Gesamt
  aussen2:      `${S}/162e226263a64125981fd99f1f54f975.jpg`,  // Chalet Eingangsseite
  terrasse1:    `${S}/1bddcbe4a1f6405d99f88b67f5c934d3.jpg`,  // Terrasse Garten
  terrasse2:    `${S}/f9fe6952d7e24ca1b87027127dbe58f5.jpg`,  // Terrasse Bergblick
  ausblick1:    `${S}/9dc4b43d9d6f48c8964bd33b67265c30.jpg`,  // Ausblick Weide Berge
  ausblick2:    `${S}/067d43aba65d487cb511b09149397eb3.jpg`,  // Ausblick Panorama
};

export const images = {
  // Hero — rotating cinematic slideshow: best winter + warm interior contrast
  hero: [
    booking.winterHero,     // Actual Chalet in pristine winter snow — warm sunlight, blue sky (Booking.com)
    wix.exteriorWinter,     // Chalet in winter snow — different angle (Wix professional)
    chalet.wohnzimmer1,     // Warm living room — contrast to winter outside
    chalet.ausblick1,       // Summer meadow & mountain view from property
  ],
  exterior: chalet.aussen1,
  heroWinter: booking.winterHero,
  winterExterior: booking.winterHero,
  living:    chalet.wohnzimmer1,
  kitchen:   chalet.kueche1,
  bedroom1:  chalet.schlaf1a,
  bedroom3:  chalet.schlaf2a,
  bedroom4:  chalet.schlaf2b,
  garden:    chalet.terrasse1,
  zirbenInterior: chalet.wohnzimmer2,
  mountain:  stock.mountain,
  mountainAlt: stock.mountainAlt,
  cozy:      chalet.wohnzimmer2,
  cozyAlt:   chalet.essen2,
  redbull:   stock.redbull,
  gold:      stock.gold,
};

// Per-unit image bundle — real chalet photos
export const unitImages = {
  zirben: {
    hero: booking.winterHero,
    interior: chalet.wohnzimmer1,
    detail: chalet.schlaf1a,
    gallery: [chalet.aussen1, chalet.wohnzimmer1, chalet.kueche1, chalet.essen1, chalet.schlaf1a, chalet.schlaf2a, chalet.bad1, chalet.terrasse1],
  },
  landhaus: {
    hero: landhausPhotos[0],
    interior: landhausPhotos[1],
    detail: landhausPhotos[2],
    gallery: landhausPhotos,
  },
  combo: {
    hero: wix.exteriorWinter,
    interior: landhausPhotos[0],
    detail: chalet.terrasse2,
    gallery: [wix.exteriorWinter, chalet.aussen1, chalet.terrasse2, chalet.wohnzimmer1, landhausPhotos[0], landhausPhotos[1], landhausPhotos[2], chalet.schlaf1a, chalet.essen1],
  },
};
